import { render } from "./VFlex.vue?vue&type=template&id=51b7a00f&scoped=true"
import script from "./VFlex.vue?vue&type=script&lang=js"
export * from "./VFlex.vue?vue&type=script&lang=js"

import "./VFlex.vue?vue&type=style&index=0&id=51b7a00f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b7a00f"]])

export default __exports__